import {useEffect, useState} from 'react';
import {useSearchParams} from 'react-router-dom';
import Layout, {Caricamento, Titolo, Vuoto} from '../Layout';
import {apiDownload, apiGet, handleApiError} from '../api';
import {dataItaliana} from '../utils';

export default function BollaPage() {
    const [params] = useSearchParams();
    const numero = params.get('bollaNumero');
    const data = params.get('bollaData');
    const [bolla, setBolla] = useState(null); // null = in caricamento

    useEffect(() => {
        apiGet('/bolla', {numeroBolla: numero, dataBolla: data})
            .then(setBolla)
            .catch(handleApiError);
    }, [numero, data]);

    // File CSV per Passepartout, generato dall'API
    function scaricaCsv() {
        apiDownload('/bolla', {numeroBolla: numero, dataBolla: data, csv: 'true', file: 'true'}, `BF${numero}.csv`)
            .catch(handleApiError);
    }

    const righe = bolla?.righe ?? [];

    return (
        <Layout>
            <Titolo indietro>Bolla {numero} <small className="text-secondary fw-normal fs-6 ms-2">{dataItaliana(data)}</small></Titolo>
            <div className="card">
                <div className="card-body">
                    {bolla === null && <Caricamento/>}
                    {bolla && righe.length === 0 && <Vuoto>Nessuna riga da mostrare.</Vuoto>}
                    {righe.length > 0 && (
                        <>
                            <table className="table table-hover mb-3">
                                <thead>
                                <tr>
                                    <th>Codice</th>
                                    <th>Articolo</th>
                                    <th className="text-end">Quantità</th>
                                </tr>
                                </thead>
                                <tbody>
                                {righe.map((r, i) => (
                                    <tr key={i}>
                                        <td className="font-monospace">{r.articoloCodUv}</td>
                                        <td>{r.articoloDescrUv}</td>
                                        <td className="text-end">{r.qtaUv}</td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                            <button type="button" className="btn btn-primary" onClick={scaricaCsv}>
                                <i className="bi-download me-2"></i>Scarica file per Passepartout
                            </button>
                        </>
                    )}
                </div>
            </div>
        </Layout>
    );
}
